import { render } from "./specialH.vue?vue&type=template&id=2c255a42&scoped=true"
import script from "./specialH.vue?vue&type=script&lang=js"
export * from "./specialH.vue?vue&type=script&lang=js"

import "./specialH.vue?vue&type=style&index=0&id=2c255a42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c255a42"]])

export default __exports__